import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { ProductComponent } from './product.component';
import { BindingCardComponent } from './binding-card/binding-card.component';
import { AlbumPricesComponent } from './album-prices/album-prices.component';
import { LandingSharedModule } from '../landing-shared/landing-shared.module';

@NgModule({
  declarations: [ProductComponent, BindingCardComponent, AlbumPricesComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    LandingSharedModule,
  ],
  providers: [],
})
export class ProductModule {}
